import { Routes } from '../routes/Routes';

const useLogin = (auth) => {
  const getRoute = auth ? Routes(auth) : Routes(false);
  return getRoute;
};

export default useLogin;
